import { setPublicPath } from 'systemjs-webpack-interop'

setPublicPath('@je-pc/tracking')
